export const MAX_CP_NAME_LENGTH = 120;
